 /*********************** Custom JS for Boost AI Search & Discovery  ************************/

var descriptionMove = setInterval(function() {
  var boostRight = document.querySelector('.boost-sd-right');
  var boostDescription = document.querySelector('.boost-sd__header-description');
  var boostPagination = document.querySelector('.boost-sd__pagination');

  if (boostRight && boostDescription && boostPagination) {
    clearInterval(descriptionMove);
    boostRight.appendChild(boostDescription.cloneNode(true));
  }
}, 10)

function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/' + value + '?view=boost');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText, xhr.status);
        xhr.onerror = () => reject(xhr.statusText, xhr.status);
        xhr.send();
    });
}

window.pfsMoneySeparator = '.';
if (window.marketMoneyFormat.indexOf(',') !== -1) {
  window.pfsMoneySeparator = ',';
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        let productHandle = '';
                        if (element.getParams().props && element.getParams().props.product) {
                            productHandle = element.getParams().props.product.handle;
                        }
                        let requestReg = formRequest(productHandle);
                        requestReg.then((res_success, status) => {
                            let res = JSON.parse(res_success);
                            let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + res.id + '"]');

                            if (productItem) {
                              if (res.preorder) {
                                let btn = productItem.querySelector('.boost-sd__btn-add-to-cart');
                                btn.classList.add('preorder-button');
                                if (btn.querySelector('.boost-sd__button-text')) {
                                  btn.querySelector('.boost-sd__button-text').innerHTML = res.preorderLabel;
                                } else if (btn.querySelector('.boost-sd__cta-button-text')) {
                                  btn.querySelector('.boost-sd__cta-button-text').innerHTML = res.preorderLabel;
                                }
                              }

                              productItem.querySelectorAll('.boost-sd__format-currency span').forEach((el) => {
                                if (el.innerText.indexOf(window.pfsMoneySeparator) == -1) {
                                  el.innerText = el.innerText + window.pfsMoneySeparator + '00';
                                }
                              });
                            }

                            if (productItem && productItem.querySelector('.boost-sd__product-price-content .boost-sd__format-currency')) {
                              productItem.querySelector('.boost-sd__product-price-content .boost-sd__format-currency:first-child span').innerHTML = res.price;
                            }

                            if (productItem && productItem.querySelector('.boost-sd__format-currency--price-compare span')) {
                              productItem.querySelector('.boost-sd__format-currency--price-compare span').innerHTML = res.comparePrice;
                            }

                            if (productItem && !productItem.querySelector('.price-members')) {
                              let memberPrice = document.createElement('p');
                              memberPrice.classList.add('price-members');
                              memberPrice.innerHTML = res.memberPrice;
                              productItem.querySelector('.boost-sd__product-price').appendChild(memberPrice);
                            }

                            productItem = document.querySelector('.boost-sd__product-item-list-view-layout[data-product-id="' + res.id + '"]');

                            if (productItem) {
                              productItem.querySelectorAll('.boost-sd__format-currency span').forEach((el) => {
                                if (el.innerText.indexOf(window.pfsMoneySeparator) == -1) {
                                  el.innerText = el.innerText + indow.pfsMoneySeparator + '00';
                                }
                              });
                            }

                            if (productItem && !productItem.querySelector('.price-members')) {
                              let memberPrice = document.createElement('p');
                              memberPrice.classList.add('price-members');
                              memberPrice.innerHTML = res.memberPrice;
                              productItem.querySelector('.boost-sd__product-item-list-view-layout-info .boost-sd__product-link').appendChild(memberPrice);
                            }
                        }).catch((res_error, status) => {
                            console.log(res_error)
                        });
                    },
                };
            },
        });

        componentRegistry.useComponentPlugin('SearchProductItem', {
            name: 'Modify ISW',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    const helpersRef = element.getHelpers();
                    let productHandle = '';
                    if (element.getParams().props && element.getParams().props.product) {
                        productHandle = element.getParams().props.product.handle;
                    }
                    let requestReg = formRequest(productHandle);
                    requestReg.then((res_success) => {
                        let res = JSON.parse(res_success);
                        let productItem = document.querySelector('.boost-sd__instant-search-autocomplete .boost-sd__suggestion-queries-item[data-id="' + res.id + '"]');
                        if (productItem && productItem.querySelector('.boost-sd__suggestion-queries-item-price .boost-sd__format-currency')) {
                          productItem.querySelector('.boost-sd__suggestion-queries-item-price .boost-sd__format-currency:first-child span').innerHTML = res.price;
                        }

                        if (productItem && productItem.querySelector('.boost-sd__format-currency--price-sale')) {
                          productItem.querySelector('.boost-sd__format-currency--price-sale span').innerHTML = res.price;
                          productItem.querySelector('.boost-sd__format-currency--price-compare span').innerHTML = res.comparePrice;
                        }

                        if (productItem && !productItem.querySelector('.price-members')) {
                          let memberPrice = document.createElement('p');
                          memberPrice.classList.add('price-members');
                          memberPrice.innerHTML = res.memberPrice;
                          productItem.querySelector('.boost-sd__suggestion-queries-item-product--right').appendChild(memberPrice);
                        }
                    }).catch((res_error) => {
                        console.log(res_error)
                    });
                }
            }),
        });

        componentRegistry.useModulePlugin('RecommendationAPI', {
            name: 'Custom Recommendation - #188936',
            apply(builder) {
                builder.on('methodFulfilled', 'get', (result) => {
                    let recommendationProducts = result.result.products;
                    if (recommendationProducts.length > 0) {
                        for (let i = 0; i < recommendationProducts.length; i++) {
                                  setTimeout(() => {
                                    if (!recommendationProducts[i]) {
                                      return;
                                    }
                            let requestReg = formRequest(recommendationProducts[i].handle);
                            requestReg.then((res_success) => {
                                let res = JSON.parse(res_success);
                                let productItems = document.querySelectorAll(`.boost-sd__recommendation .boost-sd__product-item[data-product-id="` + res.id + `"]`);

                                productItems.forEach(function(el) {
                                  el.querySelectorAll('.boost-sd__format-currency span').forEach((el) => {
                                    if (el.innerText.indexOf(window.pfsMoneySeparator) == -1) {
                                      el.innerText = el.innerText + window.pfsMoneySeparator + '00';
                                    }
                                  });

                                  if (el && el.querySelector('.boost-sd__product-price-content .boost-sd__format-currency')) {
                                    el.querySelector('.boost-sd__product-price-content .boost-sd__format-currency:first-child span').innerHTML = res.price;
                                  }

                                  if (el && el.querySelector('.boost-sd__format-currency--price-compare span')) {
                                    el.querySelector('.boost-sd__format-currency--price-compare span').innerHTML = res.comparePrice;
                                  }

                                  if (!el.querySelector('.price-members')) {
                                    let memberPrice = document.createElement('p');
                                    memberPrice.classList.add('price-members');
                                    memberPrice.innerHTML = res.memberPrice;
                                    el.querySelector('.boost-sd__product-price').appendChild(memberPrice);
                                  }
                                });
                            }).catch((res_error) => {
                                console.log(res_error)
                            });
                                    }, "1000");
                        }
                    }
                });
            }
        });

        componentRegistry.useModulePlugin('CartAPI', {
            name: 'Custom Cart API',
            apply(builder) {
                builder.on('methodFulfilled', 'addToCart', (result) => {
                          window.ajaxCart.load(false, true, false, true);
                });
            }
          });
      }
  ]);

  /* Start-Boost-235566 */

  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
      registry.useModulePlugin('RecommendationAPI', {
          name: 'Filter recomendations before call',
          apply(builder) {
              builder.on('beforeMethodCall', 'get', (payload) => {
                  try {
                      let currentCountry = window.pfsMarketCode;
                      payload.args[0].pf_t_tag = payload.args[0].pf_t_tag ? payload.args[0].pf_t_tag.concat('pfs:show:include_' + currentCountry): ['pfs:show:include_' + currentCountry];
                      if (window.pfsMarketCode) {
                        console.log(payload.args[0])
                      let currentCountry = window.pfsMarketCode;
                      payload.args[0].h_options = 'exclude_' + currentCountry;
                      //payload.args[2].pf_t_tag = payload.args[2].pf_t_tag ? payload.args[2].pf_t_tag.concat('pfs:show:include_' + currentCountry) : ['pfs:show:include_' + currentCountry];
                    }
                  } catch(error) {
                      console.warn(error);
                  }
              });
          },
      });
  });
  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
      registry.useModulePlugin('FilterAPI', {
          name: 'Recommendation API before call',
          apply(builder) {
              builder.on('beforeMethodCall', 'get', (payload) => {
                  try {
                      let currentCountry = window.pfsMarketCode;
                      payload.args[0].pf_t_tag = payload.args[0].pf_t_tag ? payload.args[0].pf_t_tag.concat('pfs:show:include_' + currentCountry) : ['pfs:show:include_' + currentCountry];
                  } catch(error) {
                      console.warn(error);
                  }
              });
          },
      });
  });
  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
      registry.useModulePlugin('SearchAPI', {
          name: 'Customize search API',
          apply(builder) {
              // Logic for in collection search feature, please only edit in TODO
              builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
                  const filterParams = payload.args[0];
                  let isApiFilterInSearchPage = false;
                  if (!filterParams) return;
                  const keys = Object.keys(filterParams);
                  if (keys?.length > 0) {
                      for (let i = 0; i < keys.length; i++) {
                          if (keys[i].startsWith('pf_')) {
                              isApiFilterInSearchPage = true;
                              break;
                          }
                      }
                  }

                  if (Shopify.locale == 'en' && !payload.args[0]?.locale) {
                      payload.args[0].locale = 'en,en';
                  }

                  // Logic runs before filtering in search results page, please only edit in TODO
                  if (window.location.pathname.indexOf('/search') !== -1 || isApiFilterInSearchPage) {
                      if (window.pfsMarketCode) {
                          let currentCountry = window.pfsMarketCode;
                          payload.args[0].pf_t_tag = payload.args[0].pf_t_tag ? payload.args[0].pf_t_tag.concat('pfs:show:include_' + currentCountry) : ['pfs:show:include_' + currentCountry];
                        }
                    }
                });
              // Logic run before calling API on ISW, please only edit in TODO
              builder.on('beforeMethodCall', 'get', (payload) => {
                  // TODO 2
                  if (!payload.args[2]) {
                      payload.args[2] = {};
                  }

                  if (Shopify.locale == 'en' && !payload.args[2]?.locale) {
                      payload.args[2].locale = 'en,en';
                  }

                  if (window.pfsMarketCode) {
                      let currentCountry = window.pfsMarketCode;
                      payload.args[2].h_options = 'exclude_' + currentCountry;
                      //payload.args[2].pf_t_tag = payload.args[2].pf_t_tag ? payload.args[2].pf_t_tag.concat('pfs:show:include_' + currentCountry) : ['pfs:show:include_' + currentCountry];
                  }
                  // END TODO
              });
          },
      });
  });

  /* End-Boost-235566 */


  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
    registry.useModulePlugin('RecommendationAPI', {
      name: 'Customize Recommendation',
      apply(builder) {
        builder.on('methodFulfilled', 'get', (result) => {
          if(result.result.products.length > 0){
            for(var j = result.result.products.length - 1; j >= 0; j--){
              let currentCountry = 'pfs:hidden:exclude_' + window.pfsMarketCode;
              let findCountry = result.result.products[j].tags.find(element => element.includes(currentCountry));

              if (findCountry) {
              result.result.products.splice(j, 1);
            }
          }
        }
      });
    },
  });
})
